document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rich-text__text.rte').forEach(function (block) {
    // 内容没超过折叠高度就不需要按钮
    if (block.scrollHeight <= block.clientHeight + 10) return;

    var fullHeight = block.scrollHeight;

    // 包一层 wrapper，作为按钮绝对定位的参照
    var wrapper = document.createElement('div');
    wrapper.className = 'rich-text-show-more-wrapper';
    block.parentNode.insertBefore(wrapper, block);
    wrapper.appendChild(block);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rich-text-show-more-btn is-expanded';
    btn.innerHTML = 'show less <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5"/></svg>';
    wrapper.appendChild(btn);

    // 默认展开
    block.classList.add('is-expanded');
    block.style.maxHeight = fullHeight + 'px';

    btn.addEventListener('click', function () {
      var expanded = block.classList.toggle('is-expanded');
      btn.classList.toggle('is-expanded', expanded);
      btn.childNodes[0].textContent = expanded ? 'show less ' : 'show more ';

      if (expanded) {
        block.style.maxHeight = fullHeight + 'px';
      } else {
        block.style.maxHeight = ''; // 收起，回到 CSS 的 220px
      }
    });
  });
});